import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

// Fragments
import './fragments/currencyPricingDataFragment';

export const getPlanPricing = async (callerId?: string) => {
  const response = await queryExecute({
    variables: {
      callerId,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query GetPlanPricing($callerId: String) {
        getPlanPricing(callerId: $callerId) {
          accent
          annual {
            activeHours
            authorizedGuestTrips
            dashboard
            emergencyCalls
            favoriteOperators
            freeGroceries
            freeRides
            goGoCare
            rideLimit
            gourmetPaymentTier {
              ...CurrencyPricingDataFragment
            }
            groceryPaymentTier {
              ...CurrencyPricingDataFragment
            }
            groceryStandingOrder
            homeServiceOneTimePaymentTier {
              ...CurrencyPricingDataFragment
            }
            homeServiceRecurringPaymentTier {
              ...CurrencyPricingDataFragment
            }
            homeServices
            insuranceAndTaxStatements
            isAlwaysOperator
            isFreePrintedInvoice
            isHighAlerts
            leisureTrips
            lovedOnesLimit
            operatorOrderedRidePrice {
              ...CurrencyPricingDataFragment
            }
            pharmacyPaymentTier {
              ...CurrencyPricingDataFragment
            }
            planKind
            price {
              AUD
              CAD
              USD
            }
            prioritySupport
            proactiveCareManagement
            ridePaymentTier {
              ...CurrencyPricingDataFragment
            }
            specialRequestPaymentTier {
              ...CurrencyPricingDataFragment
            }
            splitPayments
            turningOffReceipts
            wellnessChecks
          }
          annualPerMonthPrice {
            AUD
            CAD
            USD
          }
          annualSavingsAmount {
            AUD
            CAD
            USD
          }
          annualSavingsPercent
          monthly {
            activeHours
            authorizedGuestTrips
            dashboard
            emergencyCalls
            favoriteOperators
            freeGroceries
            freeRides
            goGoCare
            rideLimit
            gourmetPaymentTier {
              ...CurrencyPricingDataFragment
            }
            groceryPaymentTier {
              ...CurrencyPricingDataFragment
            }
            groceryStandingOrder
            homeServiceOneTimePaymentTier {
              ...CurrencyPricingDataFragment
            }
            homeServiceRecurringPaymentTier {
              ...CurrencyPricingDataFragment
            }
            homeServices
            insuranceAndTaxStatements
            isAlwaysOperator
            isFreePrintedInvoice
            isHighAlerts
            leisureTrips
            lovedOnesLimit
            operatorOrderedRidePrice {
              ...CurrencyPricingDataFragment
            }
            pharmacyPaymentTier {
              ...CurrencyPricingDataFragment
            }
            planKind
            price {
              AUD
              CAD
              USD
            }
            prioritySupport
            proactiveCareManagement
            ridePaymentTier {
              ...CurrencyPricingDataFragment
            }
            specialRequestPaymentTier {
              ...CurrencyPricingDataFragment
            }
            splitPayments
            turningOffReceipts
            wellnessChecks
          }
        }
      }
    `),
  });

  return response.data?.getPlanPricing || [];
};
